import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

export interface ManualCoordinate {
    lat: number;
    lng: number;
}

interface ManualLocationState {
    /** Si el usuario activó el modo manual (override del GPS). */
    manualModeEnabled: boolean;
    /** Coordenada simulada actual (null = aún no elegida). */
    coordinate: ManualCoordinate | null;
    /** Si el panel/sheet del globito está abierto. */
    isPanelOpen: boolean;

    setManualModeEnabled: (enabled: boolean) => void;
    setCoordinate: (coordinate: ManualCoordinate) => void;
    openPanel: () => void;
    closePanel: () => void;
    reset: () => void;
}

const initialState = {
    manualModeEnabled: false,
    coordinate: null as ManualCoordinate | null,
    isPanelOpen: false,
};

export const useManualLocationStore = create<ManualLocationState>()(
    persist(
        (set) => ({
            ...initialState,
            setManualModeEnabled: (enabled) => set({ manualModeEnabled: enabled }),
            setCoordinate: (coordinate) => set({ coordinate }),
            openPanel: () => set({ isPanelOpen: true }),
            closePanel: () => set({ isPanelOpen: false }),
            reset: () => set(initialState),
        }),
        {
            name: 'manual-location',
            storage: createJSONStorage(() => localStorage),
            partialize: (state) => ({
                manualModeEnabled: state.manualModeEnabled,
                coordinate: state.coordinate,
            }),
        },
    ),
);
